import MASTER_TYPE_CONFIG from '../../common/masterTypeConfig';
import { modeType, loadType } from '../../utils/constants';
import { ABFRL_COMPANY_IDS } from '../../utils/common';
import { getCookie } from '../../utils/cookies';

// `type` values sent by the reconciliation screen's accordions (src/home/reconciliation/*-master).
// `tabs` = modeLoadType values the accordion is rendered for; omitted means it is shown on every tab.
// Accordions that don't send a `type` are left out.
const RECONCILIATION_TYPES = {
  [MASTER_TYPE_CONFIG.CREDIT_MASTER]: [
    { label: 'Fuel Escalation', value: 9, tabs: [1, 2] },
    // Multi Pickup/Drop has its own API (multipoint/pickup) with no `type` in reconciliation; its audit logs use type 90.
    { label: 'Multi Pickup/Drop Charges', value: 90, tabs: [1] },
    { label: '2 Point Loading Charges', value: 33, tabs: [1] },
    { label: 'Minimum Weight Rate', value: 14, tabs: [3, 4, 5, 6] },
    { label: 'Minimum Freight Rate', value: 140, tabs: [3], abfrlOnly: true },
    { label: 'RHC/FOV Charges', value: 20, tabs: [2, 4, 5, 6] },
    { label: 'Fuel Surcharge', value: 21, tabs: [5, 6] },
    { label: 'RAS Charges', value: 22, tabs: [5, 6] },
    { label: 'ODA Charges', value: 24, tabs: [5, 6] },
  ],
  [MASTER_TYPE_CONFIG.DEBIT_MASTER]: [
    { label: 'Late Delivery', value: 7 },
    { label: 'Damages', value: 10 },
    // Detention, Shortage/Pilferage and POD Status have their own APIs with no `type` in reconciliation; audit logs use 91-93.
    { label: 'Detention', value: 91 },
    { label: 'Shortage/Pilferage Tolerance', value: 92 },
    { label: 'For Non Participation In Contracting Process', value: 1 },
    { label: 'For Non Participation In Indenting Process', value: 2 },
    { label: 'For Failure In Placement / Outbound Operation', value: 3 },
    { label: 'For Wrong Input of Placement / Outbound Operation', value: 4 },
    { label: 'Approved Unit Penalty Policy For Mismatch On Indented Service Check List', value: 8 },
    { label: 'Bill Charges', value: 5 },
    { label: 'POD Status', value: 93 },
    { label: 'Other Charges', value: 6 },
  ],
  [MASTER_TYPE_CONFIG.ACCOUNT_MASTER]: [
    { label: 'Billing Cycle', value: 11 },
    // Bill Number has its own API (accounts/bill/master), not type 12; its writes are tagged type 94 in reconciliation.js.
    { label: 'Bill Number', value: 94 },
    { label: 'Holiday List', value: 95 },
    { label: 'Other Charges', value: 13 },
  ],
  [MASTER_TYPE_CONFIG.ACCOUNT_EVENTS]: [
    { label: 'For Non Participation In Contracting Process', value: 1 },
    { label: 'For Non Participation In Indenting Process', value: 2 },
    { label: 'For Failure In Placement / Outbound Operation', value: 3 },
    { label: 'For Wrong Input of Placement / Outbound Operation', value: 4 },
    { label: 'Approved Unit Penalty Policy For Mismatch On Indented Service Check List', value: 7 },
    { label: 'Bill Charges', value: 5 },
    { label: 'Other Charges', value: 6 },
  ],
};

// Splits a modeLoadType tab (e.g. 'FTL Road') into its individual loadType / modeType values,
// the same way reconciliation's getModeAndLoadType builds the accordion fetch params.
export const getLoadAndModeType = (selectedModeLoadType) => {
  if (!selectedModeLoadType) return {};
  const [loadLabel, modeLabel] = selectedModeLoadType.label.split(' ');
  const load = loadType.find(val => val.label === loadLabel);
  const mode = modeType.find(val => val.label === modeLabel);
  // Audit log APIs expect snake_case load_type / mode_type (reconciliation's own APIs use loadType / modeType).
  return {
    ...(!!load && { load_type: load.value }),
    ...(!!mode && { mode_type: mode.value }),
  };
};

const isAbfrlCompany = () => {
  try {
    return ABFRL_COMPANY_IDS.includes(JSON.parse(getCookie('user')).company_id);
  } catch (e) {
    return false;
  }
};

// Types visible on the selected tab; with no tab selected, every type the master can show.
export const getReconciliationTypeOptions = (masterType, selectedModeLoadType) => {
  const types = RECONCILIATION_TYPES[+masterType] || [];
  return types
    .filter(type => !type.tabs || !selectedModeLoadType || type.tabs.includes(selectedModeLoadType.value))
    .filter(type => !type.abfrlOnly || isAbfrlCompany())
    .map(({ label, value }) => ({ label, value }));
};
